<template>
  <div class="step-2">
    <div class="page-header">
      <h2>职业身份认证申请</h2>
    </div>
    <a-form
      class="mod-form"
      layout="horizontal"
      labelAlign="left"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      :colon="false"
      :form="form"
      @submit="onSubmit"
    >
    <a-form-item label="中文姓">
        <a-input
          size="large"
          placeholder="请输入姓"
          v-decorator="[
            'surname',
            {
              initialValue: userInfo.chiSurname,
              rules: [
                {
                  required: true,
                  validator: handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]"
          :disabled="hasAuth"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="中文名">
        <a-input
          size="large"
          placeholder="请输入名"
          v-decorator="[
            'name',
            {
              initialValue: userInfo.chiName,
              rules: [
                {
                  required: true,
                  validator: handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]"
          :disabled="hasAuth"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="身份类别">
        <a-select
          size="large"
          placeholder="请选择身份类别"
          v-decorator="[
            'type',
            {
              rules: [
                {
                  required: true,
                  validator: handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]"
          :options="idTypes"
        ></a-select>
      </a-form-item>
      <a-form-item label="证件号码">
        <a-input
          size="large"
          placeholder="请输入申请认证的证件号码"
          v-decorator="[
            'idCard',
            {
              rules: [
                {
                  required: true,
                  validator: handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="工作单位/学校">
        <a-input
          size="large"
          placeholder="请输入申请认证的证件上单位/学校全称"
          v-decorator="[
            'organization',
            {
              rules: [
                {
                  required: true,
                  validator: handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="手机号码">
        <a-input
          size="large"
          placeholder="请输入手机号码"
          v-decorator="[
            'mobile',
            {
              initialValue: userInfo.phone,
              rules: [
                {
                  required: true,
                  validator: handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="E-MAIL">
        <a-input
          size="large"
          placeholder="请输入E-MAIL"
          v-decorator="[
            'email',
            {
              rules: [
                {
                  validator: handleFieldValidate
                }
              ],
              validateTrigger: 'blur'
            }
          ]"
        >
        </a-input>
      </a-form-item>
      <a-form-item label="上传附件" required>
        <p class="upload-tips">（上限5个，每个附件大小不超过5M，仅支持png、jpg、jpeg格式）</p>
        <div class="file-upload-trigger clearfix">
          <a-upload
            :file-list="fileList"
            :customRequest="handleUpload"
            list-type="picture-card"
            name="filename"
            accept=".png, .jpg, .jpeg"
            :headers="{
              token
            }"
            :transformFile="handleTransformFile"
            :beforeUpload="handleBeforeUpload"
            :locale="{
              removeFile: '删除',
              previewFile: '预览'
            }"
            @preview="handlePreview"
            @change="handleUploadChange"
          >
            <div v-if="fileList.length < fileLimit">
              <a-icon type="plus" />
            </div>
          </a-upload>
          <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancelPreview">
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </div>
      </a-form-item>
      <a-form-item :wrapper-col="wrapperColOffset">
        <a-button style="margin-right: 20px;" size="large" @click="onPrev">返回</a-button>
        <a-button type="primary" size="large" :loading="loading" html-type="submit">提交</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import { validate } from '@/utils/validate'
import { submitProfessional, uploadProfessionalFile } from '@/api/member'
import imageCompression from 'browser-image-compression'

// 图片压缩
const compressImage = async (file) => {
  let compressedFile = null
  const options = {
    maxSizeMB: 1,
    maxWidthOrHeight: 1920,
    useWebWorker: false
  }
  try {
    compressedFile = await imageCompression(file, options)
  } catch (error) {
    compressedFile = null
    console.log('图片压缩失败 >>>> ', error)
  }

  return compressedFile
}

function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  }).catch((err) => {
    console.error(err)
  })
}

export default {
  props: {
    userInfo: {
      type: Object,
      default () {
        return {}
      }
    },
    type: String,
    idTypes: Array
  },
  data () {
    return {
      labelCol: {
        span: 6
      },
      wrapperCol: {
        span: 18
      },
      wrapperColOffset: {
        offset: 6,
        span: 18
      },
      form: this.$form.createForm(this),
      loading: false,
      phone: '',
      code: '',
      errCode: '',
      fileList: [],
      fileLimit: 5,
      previewVisible: false,
      previewImage: '',
      token: this.$ls.get('USER_CENTER_TOKEN')
    }
  },
  computed: {
    hasAuth () {
      return this.userInfo && this.userInfo.authStatus === 4
    }
  },
  methods: {
    handleFieldValidate (rule, value, callback) {
      validate('professional-id-auth', this.form.getFieldsValue(), rule.fullField).then(({ valid, error }) => {
        if (valid) {
          callback()
        } else {
          callback(error)
        }
      })
    },
    onSubmit (e) {
      e.preventDefault()

      this.form.validateFields(async (errors, values) => {
        if (!errors) {
          if (this.fileList.length <= 0) {
            this.$message.error('请上传附件！')
            return
          }
          const { surname, name, email, mobile, idCard, type, organization } = values
          // 获取职业身份 tags
          const { tags } = this.idTypes.find(item => item.value === type) || {}
          // 拼接上传的附件
          const certs = this.fileList.map(({ response }) => {
            if (response && response.length) {
              const { path, url, bucketName } = response[0]
              return { path, url, bucketName }
            } else {
              return null
            }
          }).filter(item => item)

          const params = {
            surname,
            name,
            email,
            mobile,
            idCard,
            type,
            tags: tags || [],
            authInfo: {
              organization,
              certs
            }
          }

          try {
            this.loading = true
            await submitProfessional(params)
            this.$message.success('提交成功！即将返回上一页...', 1.5)
            setTimeout(() => {
              this.$emit('prev')
            }, 2000)
          } catch (err) {
            this.$error({
              content: err.message,
              centered: true
            })

            this.loading = false
            if (err.code.toString().includes(1000)) {
              this.errCode = err.code
            }
          }
        }
      })
    },
    onPrev () {
      this.form.resetFields()
      this.$emit('prev')
    },
    handleCancelPreview () {
      this.previewVisible = false
    },
    async handlePreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleUploadChange ({ fileList }) {
      this.fileList = fileList.filter(file => {
        return file.size <= 1024 * 1024 * 5
      })
    },
    handleBeforeUpload (file) {
      // 限制上传超过 5M 的图片
      if (file.size > 1024 * 1024 * 5) {
        this.$message.error('上传的附件大小不能超过5M！')
        return false
      }

      // 有些移动设备的浏览器/APP能够上传其他类型的文件，限制只能上传图片
      if (!/(.jpg|.jpeg|.png)$/g.test(file.name)) {
        this.$message.error('仅支持上传图片的类型：".png", ".jpg", ".jpeg"！')
        return false
      }

      return true
    },
    async handleTransformFile (file) {
      // 图片压缩
      const compressedFile = await compressImage(file)
      return compressedFile || file
    },
    async handleUpload (options) {
      try {
        const params = new FormData()
        params.append('filename', options.file, options.file.name)
        const data = await uploadProfessionalFile(params)
        options.onSuccess(data, options)
      } catch (error) {
        this.$message.error(error.message)
      }
    }
  }
}
</script>
